<template>

    <Form @submit="onSubmit">




        <div class="container">
            <div class="row justify-content-center">


                <div class="booking-container">

                    <div v-if="isLoading" class="d-flex justify-content-center">
                        <loader></loader>
                    </div>
                    <div v-else>


                        <div v-if="!hasAvailability">
                            <div class="row mb-3 justify-content-center">
                                <div class="col-xl-12">
                                    <info-box v-bind:type="'error'">
                                        <template v-slot:body>
                                            <strong class="mb-2">Sorry, we have no availability for your chosen treatments.</strong>
                                            <p>

                                                Please choose another treatment, time or date by pressing back or call 01325 729999 to request to be added to our waiting list.
                                            </p>

                                        </template>
                                    </info-box>
                                </div>
                            </div>

                        

                        </div>
                        <div v-else>
                            <div v-if="search.guests.length == 1" class="row d-flex justify-content-center mb-4">
                                <div class="col-md-12 col-sm-16 col-20 text-center ">
                                    <h3 class="mb-4">When would you like your first treatment to begin?</h3>
                                </div>
                            </div>
                            <div v-else class="row justify-content-center">
                                <div class="col-24 col-xl-12 d-flex justify-content-center">
                                    <div class="mb-4 bg-white  p-3 ">
                                        <label class="same-time">
                                            <input type="checkbox" v-model="showStacked" v-on:click="combinedSelected = null;" />
                                            <span>Start all guest's treatments at the same time</span>

                                        </label>

                                    </div>
                                </div>

                            </div>

                            <div v-if="!showStacked">
                                <div class="row justify-content-center calendar"
                                     v-if="availability && availability.GuestAvailability">

                                    <div v-for="(clientAvailability, cai) in availability.GuestAvailability"
                                         v-bind:key="cai"
                                         class="col-24 col-xl-12 mb-4 calendar">
                                        <div class="row mb-4">
                                            <div class="col-24 text-center">
                                                <h3>{{clientName(cai)}}</h3>
                                            </div>
                                        </div>
                                        <div class="p-0 p-lg-2">

                                            <div class="row mb-4 button-wrapper">
                                                <div class="col-12">
                                                    <button type="button"
                                                            class="btn btn--block modal-button"
                                                            v-bind:class="{'modal-button--active' : ((clientAvailability.timeOfDay == undefined && defaultTimeOfDay == 'AM') || clientAvailability.timeOfDay=='AM')}"
                                                            v-on:click="onSetTimeOfDay(clientAvailability, 'AM')">
                                                        AM
                                                    </button>
                                                </div>
                                                <div class="col-12">
                                                    <button type="button"
                                                            class="btn btn--block modal-button"
                                                            v-bind:class="{'modal-button--active' : ((clientAvailability.timeOfDay == undefined && defaultTimeOfDay == 'PM') || clientAvailability.timeOfDay=='PM')}"
                                                            v-on:click="onSetTimeOfDay(clientAvailability, 'PM')">
                                                        PM
                                                    </button>
                                                </div>
                                            </div>
                                        </div>




                                        <div class="row times" v-if=" ((clientAvailability.timeOfDay == undefined && defaultTimeOfDay == 'AM') || clientAvailability.timeOfDay=='AM')">


                                            <span class="col-12 col-lg-6 mb-3"
                                                  v-on:click="onSelection(cai, t)"
                                                  v-for="(t, ca) in clientAvailability.Periods.AM"
                                                  v-bind:key="ca">
                                                <span class="time-slot h-100"
                                                      v-bind:class="{'time-slot--active': isSelected(cai, t), 'timeslot--disabled' : checkIsDisabled(t)}">

                                                    <span class="spa-time">{{t.DisplayTime}}</span>

                                                </span>
                                            </span>

                                        </div>

                                        <div class="row times" v-if="((clientAvailability.timeOfDay == undefined && defaultTimeOfDay == 'PM') || clientAvailability.timeOfDay==='PM' )">


                                            <span class="col-12 col-lg-6 mb-3"
                                                  v-on:click="onSelection(cai, t)"
                                                  v-for="(t, ca) in clientAvailability.Periods.PM"
                                                  v-bind:key="ca">
                                                <span class="time-slot h-100"
                                                      v-bind:class="{'time-slot--active': isSelected(cai, t), 'timeslot--disabled' : checkIsDisabled(t)}">


                                                    <span class="spa-time">{{t.DisplayTime}}</span>

                                                </span>
                                            </span>
                                        </div>


                                    </div>

                                </div>
                            </div>
                            <div v-if="showStacked">

                                <div class="row justify-content-center"
                                     v-if="availability ">

                                    <div class="col-24 col-xl-12 mb-4 calendar">
                                        <div class="row mb-4">
                                            <div class="col-24 text-center">
                                                <h3>First treatment time for {{combinedGuests}}</h3>

                                            </div>
                                        </div>


                                        <div class="row mb-4 button-wrapper">
                                            <div class="col-12">
                                                <button type="button"
                                                        class="btn btn--block modal-button"
                                                        v-bind:class="{'modal-button--active' : ((stackedCalendarTimeOfDay == 'AM'))}"
                                                        v-on:click="stackedCalendarTimeOfDay = 'AM';">
                                                    AM
                                                </button>
                                            </div>
                                            <div class="col-12">
                                                <button type="button"
                                                        class="btn btn--block modal-button"
                                                        v-bind:class="{'modal-button--active' : ((stackedCalendarTimeOfDay == 'PM'))}"
                                                        v-on:click="stackedCalendarTimeOfDay = 'PM'; ">
                                                    PM
                                                </button>
                                            </div>
                                        </div>


                                        <div class="row times" v-if="stackedCalendarTimeOfDay =='AM'">

                                            <span class="col-12 col-lg-6 mb-3"
                                                  v-on:click="onCombinedSelection(t)"
                                                  v-for="(t, ca) in stackedCalendar.Periods.AM"
                                                  v-bind:key="ca">
                                                <span class="time-slot h-100"
                                                      v-bind:class="{'time-slot--active':  t.StartTime === combinedSelected?.StartTime, 'timeslot--disabled' : checkIsDisabled(t)}">

                                                    <span class="spa-time">{{t.DisplayTime}}</span>

                                                </span>
                                            </span>

                                        </div>

                                        <div class="row times" v-else>

                                            <span class="col-12 col-lg-6 mb-3"
                                                  v-on:click="onCombinedSelection(t)"
                                                  v-for="(t, ca) in stackedCalendar.Periods.PM"
                                                  v-bind:key="ca">
                                                <span class="time-slot h-100"
                                                      v-bind:class="{'time-slot--active': t.StartTime === combinedSelected?.StartTime, 'timeslot--disabled' : checkIsDisabled(t)}">


                                                    <span class="spa-time">{{t.DisplayTime}}</span>

                                                </span>
                                            </span>
                                        </div>


                                    </div>

                                </div>




                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </div>





        <actions-bar>
            <template v-slot:actions>
                <div class="row d-none d-sm-flex">
                    <div class="col-10">

                        <button v-on:click="onBack"
                                type="button"
                                class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>

                    <div class="col-4 d-flex flex-column align-items-center">

                        <span v-if="total > 0" class="spa-total-label">Total</span>
                        <span v-if="total > 0" class="spa-total">&pound;{{total}}</span>

                    </div>

                    <div class="col-10 d-flex justify-content-end">
                        <button class="btn btn--slate-blue btn--continue"
                                v-bind:disabled="!canSubmit"
                                type="submit">
                            Next

                        </button>
                    </div>
                </div>

                <div class="row d-sm-none">

                    <div class="col-24 d-flex flex-row align-items-center justify-content-center mb-3">

                        <span v-if="total > 0" class="spa-total-label me-2">Total</span>
                        <span v-if="total > 0" class="spa-total">&pound;{{total}}</span>

                    </div>

                    <div class="col-12">

                        <button v-on:click="onBack"
                                type="button"
                                class="btn btn--transparent btn--back">
                            Back
                        </button>
                    </div>

                    <div class="col-12 d-flex justify-content-end">
                        <button class="btn btn--slate-blue btn--continue"
                                v-bind:disabled="!canSubmit"
                                type="submit">
                            Add ons

                        </button>
                    </div>
                </div>
            </template>
        </actions-bar>

    </Form>
</template>

<script>


    import { Field, Form, ErrorMessage } from "vee-validate";
    import Loader from '@/shared/components/Loader.vue';
    import InfoBox from '@/shared/components/InfoBox.vue';
    import ActionsBar from '@/shared/components/ActionsBar.vue';

    import { store } from '../store/index';

    import { _ } from 'vue-underscore';


    export default {
        name: 'SpaTreatmentTreatmentTimes',
        components: {
            ActionsBar,
            Loader,

            Field,
            Form,
            ErrorMessage,
            InfoBox
        },
        mounted() {
            let o = this;
            this.isLoading = true;

       
            let payload = {
                id: this.session.Id,
                item: {
                    SessionId: this.session.Id,
                    AppointmentExtras: this.search.spaDay
                        .Extras
                        .filter(item => item.SystemType == "APPOINTMENT")
                        .flatMap(function (item) {
                            return item
                                .Codes
                                .filter(i => i.Guests == null || i.Guests == o.search.guests.length)
                                .map(function (inner) {
                                    let activity = o.activities.find(a => a.Code == inner.Code);

                                    if (activity == null) { return null }
                                    return activity.ID;
                                })
                        }).filter(i => i != null),
                    Date: this.search.date,
                    StartDate: this.search?.guests[0]?.spaDayArrivalTime?.selectedItem?.StartDateTime,
                    EndDate: moment(this.search.date).format("YYYY-MM-DD") + "T" + this.search?.spaDay?.EndTime,
                    GuestRequirements: [],

                }
            };

            for (let gi = 0; gi < this.search.guests.length; gi++) {
                let guest = this.search.guests[gi];

                let activities = guest.treatments.map(item => item.duration.Id);
                payload.item.GuestRequirements.push({
                    GuestIndex: gi,
                    Activities: activities

                });

            }


            store.dispatch('fetchAvailability', payload).then((t) => {
                this.isLoading = false;

            });


        },
        computed: {
            session() {
                return store.getters.session
            },
            booking() {
                return store.getters.booking;
            },
            configuration() {
                return store.getters.configuration;
            },

            search() {
                return store.getters.search;
            },
            activities() {
                return store.getters.activities;
            },
            hasAvailability() {
                let result = false;

                let a = this.stackedCalendar;


                for (let i = 0; i < a.Periods.AM.length; i++) {
                    let am = a.Periods.AM[i];
                    if (am.IsAvailable) {
                        return true;
                    }
                }
                for (let j = 0; j < a.Periods.PM.length; j++) {
                    let pm = a.Periods.PM[j];
                    if (pm.IsAvailable) {
                        return true;
                    }
                }



                return result;
            },

            availability() {
                //we need to filter times here...

                let availability = store.getters.availability;

                if (availability?.GuestAvailability != null) {

                    console.log("this.search.guests", this.search.guests);

                    let guestMaxArrivalTime = moment(_.max(this.search.guests.map(item => moment.utc(item.spaDayArrivalTime.selectedItem.EndDateTime))));
                    let bandEnd = this.search.spaDay.bookingDetails.TimeBands.find(item => item.BandNumber == this.search.spaDay.Band)?.EndTime;
                    let bandEndTime = moment.utc(bandEnd, "HH:mm")
                    let dayEndTime = moment.utc(this.search.date).add(bandEndTime.hour(), 'h').add(bandEndTime.minutes(), 'm');
                    let restaurantAvailability = this.search?.restaurant?.selectedTime?.TimeSlot;
                    let restaurantStartTime = null;
                    let restaurantEndTime = null;

                    if (restaurantAvailability != null) {
                        var restaurantDuration = this.search?.restaurant?.duration ?? 120;
                        if (restaurantDuration != null) {
                            restaurantStartTime = moment.utc(restaurantAvailability);
                            restaurantEndTime = moment.utc(restaurantAvailability).add(restaurantDuration, 'm');

                        }
                    }
                 

                    for (let gai = 0; gai < availability.GuestAvailability.length; gai++) {
                        let guestAvailability = availability.GuestAvailability[gai];

                        let searchGuest = this.search.guests[guestAvailability.GuestIndex];
                        let spaGardenStart, spaGardenEnd;
                        if (searchGuest.spaArrivalTime != undefined && searchGuest.spaArrivalTime != null) {

                            spaGardenStart = moment.utc(searchGuest.spaArrivalTime.StartDateTime);
                            spaGardenEnd = moment.utc(searchGuest.spaArrivalTime.EndDateTime).add(15, 'm');

                        }
                        else {
                            spaGardenStart = null;
                            spaGardenEnd = null;
                        }

                        var times = guestAvailability.Periods.AM;

                        for (let ti = 0; ti < times.length; ti++) {
                            let time = times[ti];
                            if (!time.IsAvailable || time.TreatmentTimes == null) {
                                continue;
                            }

                            let treatmentTime = moment.utc(time.StartTime);
                            let treatmentTimeEnd = moment.utc(time.TreatmentTimes[0].EndTime);

                            // After arrival
                            if (treatmentTime < guestMaxArrivalTime) {
                                console.log("Before arrival", time);
                                time.IsAvailable = false;
                                time.TreatmentTimes = null
                                continue;
                            }

                            if (treatmentTimeEnd > dayEndTime) {
                                console.log("After departure", time);
                                time.IsAvailable = false;
                                time.TreatmentTimes = null
                                continue;
                            }

                            //check spa garden
                      
                            if (spaGardenStart != null && spaGardenEnd != null) {
                        
                                if (treatmentTime.isBetween(spaGardenStart, spaGardenEnd)
                                    || treatmentTime.isSame(spaGardenStart)
                                    || treatmentTimeEnd.isBetween(spaGardenStart, spaGardenEnd)
                                    || treatmentTimeEnd.isSame(spaGardenEnd)) {

                                    console.log("During Spa Garden", time);
                                    time.IsAvailable = false;
                                    time.TreatmentTimes = null
                                    continue;
                                }
                            }

                            if (restaurantStartTime != null && restaurantEndTime != null) {

                                if (treatmentTime.isBetween(restaurantStartTime, restaurantEndTime)
                                    || treatmentTime.isSame(restaurantStartTime)
                                    || treatmentTimeEnd.isBetween(restaurantStartTime, restaurantEndTime)
                                    || treatmentTimeEnd.isSame(spaGardenEnd)) {

                                    time.IsAvailable = false;
                                    time.TreatmentTimes = null
                                    continue;
                                }
                            }






                        }



                        var times2 = guestAvailability.Periods.PM;

                        for (let ti = 0; ti < times2.length; ti++) {
                            let time2 = times2[ti];


                            if (!time2.IsAvailable || time2.TreatmentTimes == null) {
                                continue;
                            }
                            let treatmentTime2 = moment(time2.StartTime);
                            let treatmentTimeEnd2 = moment.utc(time2.TreatmentTimes[0].EndTime);

                            //After arrival
                            if (treatmentTime2.isBefore(guestMaxArrivalTime, )) {
                                console.log("Before arrival", time2);
                                console.log("Before arrival", treatmentTime2);
                                console.log("Before arrival", guestMaxArrivalTime);
                                time2.IsAvailable = false;
                                time2.TreatmentTimes = null
                                continue;
                            }

                            if (treatmentTimeEnd2 > dayEndTime) {
                                console.log("After departure", time2, treatmentTimeEnd2, dayEndTime);
                                time2.IsAvailable = false;
                                time2.TreatmentTimes = null
                                continue;
                            }


                            //check spa garden

                            if (spaGardenStart != null && spaGardenEnd != null) {

                                if (treatmentTime2.isBetween(spaGardenStart, spaGardenEnd)
                                    || treatmentTime2.isSame(spaGardenStart)
                                    || treatmentTimeEnd2.isBetween(spaGardenStart, spaGardenEnd)
                                    || treatmentTimeEnd2.isSame(spaGardenEnd)) {
                                    console.log("During Spa Garden", time2, spaGardenStart, spaGardenEnd);
                                    time2.IsAvailable = false;
                                    time2.TreatmentTimes = null
                                    continue;
                                }
                            }


                            if (restaurantStartTime != null && restaurantEndTime != null) {
                                if (treatmentTime2.isBetween(restaurantStartTime, restaurantEndTime)
                                    || treatmentTime2.isSame(restaurantStartTime)
                                    || treatmentTimeEnd2.isBetween(restaurantStartTime, restaurantEndTime)
                                    || treatmentTimeEnd2.isSame(spaGardenEnd)) {
                                    time2.IsAvailable = false;
                                    time2.TreatmentTimes = null
                                    continue;
                                }
                            }






                        }




                    }

                    return store.getters.availability;
                }
                return null;
            },
            availableExtras() {
                return this.search.spaDay.Extras;

            },
            combinedGuests() {

                var hasAnd = true;
                var names = '';
                for (var i = 0; i < this.search.guests.length; i++) {
                    let guest = this.search.guests[i];
                    names += guest.firstName;

                    if (this.search.guests.length - 2 == i) {
                        names += hasAnd ? ' & ' : ' or ';
                    }
                    else if (this.search.guests.length > i + 1) {
                        names += ', ';
                    }
                }
                return names.trim();
            },

            stackedCalendar() {
                let result = {
                    Periods: {
                        AM: [],
                        PM: []
                    },
                    timeOfDay: 'AM'
                };
                if (this.availability?.GuestAvailability != null) {

                    let ga = this.availability.GuestAvailability[0];


                    for (var ami = 0; ami < ga.Periods.AM.length; ami++) {
                        let am = ga.Periods.AM[ami];

                        var tempTime = {
                            StartTime: am.StartTime,
                            DisplayTime: am.DisplayTime,
                            IsAvailable: true,
                            GuestTimes: [{ GuestIndex: 0, TreatmentTimes: am.TreatmentTimes }],
                        };

                        for (var igi = 1; igi < this.availability.GuestAvailability.length; igi++) {
                            let iga = this.availability.GuestAvailability[igi];
                            var sameStartTime = iga.Periods.AM.find(st => st.StartTime == am.StartTime);

                            tempTime.GuestTimes.push({ GuestIndex: igi, TreatmentTimes: sameStartTime.TreatmentTimes })

                        }

                        var hasNullTime = tempTime.GuestTimes.filter(item => item.TreatmentTimes == null);
                        tempTime.IsAvailable = hasNullTime.length == 0;

                        result.Periods.AM.push(tempTime);

                    }

                    for (var pmi = 0; pmi < ga.Periods.PM.length; pmi++) {
                        let pm = ga.Periods.PM[pmi];

                        var tempTime = {
                            StartTime: pm.StartTime,
                            DisplayTime: pm.DisplayTime,
                            IsAvailable: true,
                            GuestTimes: [{ GuestIndex: 0, TreatmentTimes: pm.TreatmentTimes }],
                        };

                        for (var igi = 1; igi < this.availability.GuestAvailability.length; igi++) {
                            let iga = this.availability.GuestAvailability[igi];
                            var spmeStartTime = iga.Periods.PM.find(st => st.StartTime == pm.StartTime);

                            tempTime.GuestTimes.push({ GuestIndex: igi, TreatmentTimes: spmeStartTime.TreatmentTimes })

                        }

                        var hasNullTime = tempTime.GuestTimes.filter(item => item.TreatmentTimes == null);
                        tempTime.IsAvailable = hasNullTime.length == 0;

                        result.Periods.PM.push(tempTime);

                    }




                }


                return result;
            },



            total() {

                return store.getters.dayTotal;
            },

            canSubmit() {

                for (let gi = 0; gi < this.search.guests.length; gi++) {
                    let guest = this.search.guests[gi];
                    if (guest.startTime == undefined || guest.startTime == null) {
                        return false;
                    }
                }

                return true;

            },
        },
        data() {

            return {
                defaultTimeOfDay: 'AM',
                isLoading: false,
                showStacked: true,
                stackedCalendarTimeOfDay: 'AM',
                combinedSelected: null
            }
        },
        methods: {

            onCombinedSelection(t) {

                if (!t.IsAvailable) {
                    return;
                }
                t.IsSelected = true;
                this.combinedSelected = t;

                for (var i = 0; i < t.GuestTimes.length; i++) {
                    let payload = {
                        guestIndex: i,
                        selection: {
                            StartTime: t.StartTime,
                            TreatmentTimes: t.GuestTimes[i].TreatmentTimes,
                            IsAvailable: t.IsAvailable
                        }
                    };

                    store.dispatch("selectStartTime", payload);
                }
            },
            onSelection: function (gi, t) {
                if (!t.IsAvailable) {
                    return;
                }
                let payload = {
                    guestIndex: gi,
                    selection: t
                };

                store.dispatch("selectStartTime", payload);

            },
            onSubmit: function (values) {

                if (this.availableExtras != null && this.availableExtras.length) {


                    this.$router.push({ name: 'spa_day_add_ons', params: { id: this.session.Id } });
                }
                else {
                    this.$router.push({ name: 'spa_day_details', params: { id: this.session.Id } });
                }


            },
            onBack: function () {
                this.$router.push({
                    name: 'spa_day_treatments', params: { id: this.session.Id }
                });
            },

            onSetTimeOfDay(a, timeOfDay) {

                a.timeOfDay = timeOfDay;
            },
            isSelected(a, t) {

                let guest = this.search.guests[a];
                if (guest !== undefined && guest.startTime !== undefined) {


                    return t == guest.startTime;
                }
                return false;

            },
            formatTime(dateTime) {
                let date = moment(dateTime);
                return date.format("HH:mm");
            },
            checkIsDisabled(t) {
                return !t.IsAvailable;
            },
            clientName(index) {


                let result = store.getters.guestName(index);
                return result;
            },

        }
    }
</script>


<style src="@/shared/css/guests.css"></style>

<style scoped>
    .spa-time {
        display: block;
        font-weight: bold;
    }

    .time-slot {
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        cursor: pointer;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px;
    }


        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 0.15);
            cursor: not-allowed;
        }


        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }

    .timeslot {
        cursor: pointer !important;
    }

    .timeslot--disabled,
    .timeslot--disabled:hover {
        background: #ddd !important;
        color: #000 !important;
        cursor: default;
    }

    .modal-button {
        background-color: #fff;
        position: relative;
        color: #000;
        border-color: #fff;
        margin-bottom: 30px !important;
    }


        .modal-button:after {
            border-top: 10px solid #fff;
            display: block;
            position: absolute;
            content: ' ';
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            z-index: 10;
        }



    .modal-botton:hover,
    .modal-button--active {
        background-color: #425260;
        border-color: #425260;
        color: #fff;
    }

        .modal-botton:hover,
        .modal-button--active:after {
            border-top: 10px solid #425260;
        }


    .spa .spa-total-label {
        font-weight: 300;
        display: block;
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
    }

    .spa .spa-total {
        font-weight: bold;
        display: block;
        font-size: 24px;
        text-align: center;
    }
</style>

<style scoped>
    .same-time {
        display: flex;
        align-items: baseline;
    }

        .same-time span {
            position: relative;
            display: flex;
            padding-left: 7px;
            line-height: 1.2;
        }
</style>